import {create} from 'zustand';
import type {VelaDepositFacts} from '../engine/types';

type VelaDepositStore = {
  deposit: VelaDepositFacts;
  setDeposit: (deposit: VelaDepositFacts) => void;
};

export const EMPTY_VELA_DEPOSIT: VelaDepositFacts = {
  hasDeposit: false,
  hasProtection: false,
  isRetention: true,
  depositAmount: '',
  protectionAmount: '',
  protectionLimit: '',
  depositFee: '',
};

export const useVelaDepositStore = create<VelaDepositStore>(set => ({
  deposit: EMPTY_VELA_DEPOSIT,
  setDeposit: deposit => set({deposit}),
}));
